import cardActions from 'ServicesActions/card'
import { loadCurretUser } from 'Services/helpers'
import { filterCardsByStatus, sortArrayByObjectKey, setDriveFolder } from 'Utils'

export const namespaced = true

export const state = {
  userCards: null,
  currentCard: null,
}

export const mutations = {
  SET_CARDS(state, cards) {
    state.userCards = cards
  },

  SET_CURRENT_CARD(state, card) {
    state.currentCard = card
  },

  UNSET_CURRENT_CARD(state) {
    state.currentCard = null
  },

  SET_OLD_CARD_UPDATE(state, { oldCard, updatedCard }) {
    const newCardData = Object.assign(oldCard, updatedCard.data)
    oldCard = newCardData
  },

  SET_CURRENT_CARD_UPDATE(state, { newValues }) {
    const keyToUpdate = Object.keys(newValues)[0]
    // console.log(newValues, keyToUpdate)
    state.currentCard[keyToUpdate] = newValues[keyToUpdate]
  },

  SET_CURRENT_CARD_USER(state, user) {
    state.currentCard.users.push(user)
  },

  UNSET_CURRENT_CARD_USER(state, user) {
    state.currentCard.users = state.currentCard.users.filter((u) => u.id != user.id)
  },

  // Comments
  SET_NEW_COMMENT(state, comment) {
    state.currentCard.activities.unshift(comment)
  },

  SET_COMMENT_UPDATE(state, comment) {
    let activity = state.currentCard.activities.find((a) => a.id == comment.id)
    Object.assign(activity, comment)
  },

  SET_COMMENT_DELETED(state, commentId) {
    state.currentCard.activities = state.currentCard.activities.filter((a) => a.id != commentId)
  },
}

export const actions = {
  async getCard(context, cardId) {
    try {
      let updatedCard = await cardActions.get.card(cardId)
      updatedCard.data.drive_folder = setDriveFolder(updatedCard.data.drive_folder)
      // updating card for future edition
      if (loadCurretUser().type === 'CLIENT') {
        context.dispatch('client/updateClientOldCard', { cardId, updatedCard }, { root: true })
      } else {
        context.dispatch('updateUserOldCard', { cardId, updatedCard })
      }
      // setting the current card
      context.commit('SET_CURRENT_CARD', updatedCard.data)
      return updatedCard
    } catch (error) {
      return error
    }
  },

  async getCards({ commit }) {
    try {
      let cards = await cardActions.get.cards()
      cards.data = sortArrayByObjectKey(cards.data, 'status_changed', true)
      commit('SET_CARDS', cards.data)
      return cards
    } catch (error) {
      return error
    }
  },

  async updateCard(context, cardInfo) {
    try {
      const updatedCard = await cardActions.update.card(cardInfo.id, cardInfo.newValues)
      // updating card for future edition
      if (loadCurretUser().type === 'EMPLOYEE') {
        context.dispatch('updateUserOldCard', { cardId: cardInfo.id, updatedCard })
      }
      // client cards
      context.dispatch(
        'client/updateClientOldCard',
        { cardId: cardInfo.id, updatedCard },
        { root: true }
      )
      // updating store
      // user was added ⤵
      if (cardInfo.user) {
        if (cardInfo.action === 'add') {
          // add user
          context.commit('SET_CURRENT_CARD_USER', { ...cardInfo.user })
        } else {
          // remove user
          context.commit('UNSET_CURRENT_CARD_USER', { ...cardInfo.user })
        }
        return updatedCard
      }
      // else
      context.commit('SET_CURRENT_CARD_UPDATE', { ...cardInfo })
      return updatedCard
    } catch (error) {
      return error
    }
  },

  updateUserOldCard(context, { cardId, updatedCard }) {
    if (!context.state?.userCards) return
    const oldCard = context.getters.getCard(cardId)
    if (!oldCard) return
    // updating card for future edition
    context.commit('SET_OLD_CARD_UPDATE', { oldCard, updatedCard })
  },

  removeCurrentCard({ commit }) {
    commit('UNSET_CURRENT_CARD')
  },

  recieveCards({ commit }, cards) {
    commit('SET_CARDS', cards)
  },

  // ACTIVITIES
  async addComment(context, { cardId, comment }) {
    try {
      const newComment = await cardActions.activity.createComment(cardId, comment)
      context.commit('SET_NEW_COMMENT', newComment.data)
    } catch (error) {
      return error
    }
  },

  async updateComment(context, { cardId, activityId, comment }) {
    try {
      const newComment = await cardActions.activity.updateComment(cardId, activityId, comment)
      context.commit('SET_COMMENT_UPDATE', newComment.data)
      return newComment
    } catch (error) {
      return error
    }
  },

  async deleteComment(context, { cardId, activityId }) {
    try {
      const response = await cardActions.activity.deleteComment(cardId, activityId)
      context.commit('SET_COMMENT_DELETED', activityId)
      return response
    } catch (error) {
      return error
    }
  },
}

export const getters = {
  getCurrentCard(state) {
    return state.currentCard
  },

  getCard(state) {
    return (id) => {
      return state.userCards.filter((card) => card.id == id)[0]
    }
  },

  getCardsByUser(state) {
    return (id) => {
      const userCards = state.userCards.filter((card) => {
        if (card.users.some((user) => user.id === id)) {
          return card
        }
      })
      return userCards
    }
  },

  getUserCardsByStatus(state, getters, rootState, rootGetters) {
    return (status = []) => {
      const user = rootGetters['user/getCurrentUser'].id
      const cards = getters.getCardsByUser(user)
      return filterCardsByStatus(cards, status)
    }
  },

  getUnassignedCards(state) {
    if (state.userCards) {
      return state.userCards.filter((card) => {
        if (!card.users.some((user) => user.type === 'EMPLOYEE') && card.status !== 'completed')
          return card
      })
    }
  },
}
